import React from "react";
import { CustomIconProps } from "../../utils/interfaces/user/icons";

const IFrameIcon: React.FC<CustomIconProps & { outlined?: boolean }> = ({
  width,
  height,
  fill,
  outlined,
  ...rest
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "24"}
      height={height ? height : "24"}
      viewBox="0 0 24 24"
      fill={outlined ? "none" : fill}
      stroke={outlined ? fill : "none"}
      strokeWidth={outlined ? "1.5" : "0"}
      {...rest}
    >
      <path
        d="m13 20h7v-16h-16v7h7c1.1045695 0 2 .8954305 2 2zm-2 0v-7h-7v7zm-7-18h16c1.1045695 0 2 .8954305 2 2v16c0 1.1045695-.8954305 2-2 2h-16c-1.1045695 0-2-.8954305-2-2v-16c0-1.1045695.8954305-2 2-2z"
        fill={outlined ? "none" : fill}
      />
    </svg>
  );
};

export default IFrameIcon;
{
  /* <svg
  height="24"
  viewBox="0 0 24 24"
  width="24"
  xmlns="http://www.w3.org/2000/svg"
></svg>; */
}
